import React, {FC} from 'react'
import {Formik, Form, Field, FieldProps} from 'formik'
import {ReactSelectInput, Input} from '../../../../../_metronic/partials/controls'
import {useIntl} from 'react-intl'
import {governorateOptions} from '../../../../options'
import { RegisterUserRequest } from '../../../../../redux/reducers/auth/types'
import * as Yup from 'yup'

export interface submitPersonalInformationFormProps {
  governorate: string
  location: string
  zipCode: string
  birthDay: string
  placeOfBirth: string
}
interface PersonalInformationProps {
  onSubmit: (vals: submitPersonalInformationFormProps) => void
  user: RegisterUserRequest
  btnRef: any
}

const PersonalInformation: FC<PersonalInformationProps> = ({btnRef, onSubmit, user}) => {
  const intl = useIntl()

  const getGovernorateValue = (val?: string) => {
    if (!val) return null
    return governorateOptions.find((gov) => gov.value === val)
  }

  const schema = Yup.object().shape({
    governorate: Yup.string()
      .trim()
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    location: Yup.string()
      .trim()
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    zipCode: Yup.string()
    .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    birthDay: Yup.string()
      .trim()
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    placeOfBirth: Yup.string()
      .trim()
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
  })

  return (
    <Formik
      validationSchema={schema}
      initialValues={{
        governorate: user.governorate,
        location: user.location,
        zipCode: user.zipCode,
        birthDay: user.birthDay,
        placeOfBirth: user.placeOfBirth,
      }}
      onSubmit={(vals) => {
        onSubmit(vals)
      }}
    >
      {({handleSubmit, values, setValues, setFieldValue, errors}) => (
        <Form>
          <div className='row'>
            <div className='col-sm'></div>
            <h2 className='fw-bolder d-flex align-items-center text-dark'>
              {intl.formatMessage({id: 'MENU.PERSONAL_INFORMATION'})}
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Billing is issued based on your selected account type'
              ></i>
            </h2>
            <div className='text-gray-400 fw-bold fs-6'>
              {intl.formatMessage({id: 'MENU.PERSONAL_INFORMATION_DESC'})}
            </div>
          </div>

          <div className='row'>
            <div className='col-sm'>
              <Field name='governorate'>
                {({form, field}: FieldProps) => (
                  <ReactSelectInput
                    label={intl.formatMessage({id: 'SELECT.LABEL.GOVERNORATE'})}
                    required={true}
                    placeholder={intl.formatMessage({id: 'SELECT.PLACEHOLDER.GOVERNORATE'})}
                    value={getGovernorateValue(values.governorate)}
                    options={governorateOptions}
                    isClearable={false}
                    onChange={(val: any) => {
                      setFieldValue('governorate', val.value)
                    }}
                    error={
                      form.touched[field.name] && form.errors[field.name]
                        ? (form.errors[field.name] as string)
                        : undefined
                    }
                  />
                )}
              </Field>
            </div>
          </div>

          <div className='row'>
            <div className='col-sm col-md-6'>
              <Field
                name='location'
                label={intl.formatMessage({id: 'INPUT.CITY.LABEL'})}
                placeholder={intl.formatMessage({id: 'INPUT.CITY.PLACEHOLDER'})}
                component={Input}
                required={true}
              />
            </div>
            <div className='col-sm col-md-6'>
              <Field
                name='zipCode'
                label={intl.formatMessage({id: 'INPUT.ZIPCODE.LABEL'})}
                placeholder={intl.formatMessage({id: 'INPUT.ZIPCODE.PLACEHOLDER'})}
                component={Input}
                required={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm col-md-6'>
              <Field
                name='birthDay'
                label={intl.formatMessage({id: 'INPUT.BIRTHDAY.LABEL'})}
                placeholder={intl.formatMessage({id: 'INPUT.BIRTHDAY.PLACEHOLDER'})}
                component={Input}
                type='date'
                required={true}
              />
            </div>
            <div className='col-sm col-md-6'>
              <Field
                name='placeOfBirth'
                label={intl.formatMessage({id: 'INPUT.PLACE_OF_BIRTH.LABEL'})}
                placeholder={intl.formatMessage({id: 'INPUT.PLACE_OF_BIRTH.PLACEHOLDER'})}
                component={Input}
                required={true}
              />
            </div>
          </div>
          <button
            style={{display: 'none'}}
            type='submit'
            ref={btnRef}
            onSubmit={() => handleSubmit()}
          />
        </Form>
      )}
    </Formik>
  )
}

export default PersonalInformation
